import { makeStyles } from "@material-ui/core/styles";
import gameMuiTheme from "../../../../layout/styles/GameMuiTheme";

const selectorStyles = makeStyles({
	hotkey: {
		textDecoration: "underline",
		fontWeight: "bold"
	},
	teamSelectorBox: {
		display: "flex",
		flexDirection: ({ swapTeams }) => (swapTeams ? "row-reverse" : "row"),
		justifyContent: "center",
		alignItems: "center",
		gap: 20
	},
	penaltyFilterTextfield: {
		"& .MuiFilledInput-root": {
			background: gameMuiTheme.palette.common.white
		}
	},
	penaltyFilterBox: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "10px",
		position: "sticky",
		top: 0,
		zIndex: 1,
		"backdrop-filter": "blur(10px)"
	}
});

export default selectorStyles;
